import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { RoleEnum } from '../enumurations/RoleEnum';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  userApi = environment.apiServer + '/users/'

  constructor(private httpClient: HttpClient) { }

  public passwordInitialised = false;
  public requestNewPassword = false;
  public serverErrorAlert = false;
  public activationLinkAlert = false;

  saveUser(state, userForm: FormGroup, nationality) {
    let mappedUser = this.mapUser(userForm, nationality, state);
    return this.httpClient.put(this.userApi, mappedUser);
  }

  checkGroup(userId, type, appId, coursId) {
    let request = {
      enseignantId: userId,
      type: type
    }
    if (appId) {
      request["apprentissageIds"] = appId;
    }
    if (coursId)
      request["cours"] = coursId;
    return this.httpClient.post(this.userApi + "checkGroups", null, { params: request });
  }

  editUser(state, userForm: FormGroup, nationality, userId) {
    let mappedUser = this.mapUser(userForm, nationality, state);
    mappedUser["userId"] = userId;
    return this.httpClient.put(this.userApi, mappedUser);
  }

  editProfile(userForm: FormGroup, nationality, userId) {
    let mappedUser = this.mapProfile(userForm, nationality);
    mappedUser["userId"] = userId;
    return this.httpClient.put(this.userApi + "profile", mappedUser);
  }

  saveEnseignant(state, userForm: FormGroup, nationality) {
    let mappedUser = this.mapEnseignant(userForm, nationality, state);
    console.log(mappedUser);
    return this.httpClient.put(this.userApi + "AddEnseignant", mappedUser);
  }

  editPassword(params) {
    return this.httpClient.put(environment.apiServer + "/users/password", params);
  }

  editEnseignant(state, userForm: FormGroup, nationality, userId, enseignantInfo) {
    let mappedUser = this.mapEnseignant(userForm, nationality, state);
    console.log(mappedUser);
    mappedUser['userDto']['userId'] = userId;
    mappedUser["enseignantInfoId"] = enseignantInfo;
    return this.httpClient.put(this.userApi + "AddEnseignant", mappedUser);
  }

  getUserById(id) {
    return this.httpClient.get(this.userApi + id);
  }

  validateEnseignant(verdict, reason, id) {
    return this.httpClient.post(this.userApi + "enseignant/validation", {
      demandeId: id,
      motif: reason,
      status: verdict
    })
  }

  getPhotoProfil(userKey) {
    return this.httpClient.get(this.userApi + "photoProfil/" + userKey, { responseType: 'blob' });
  }

  getEnseignants(params) {
    return this.httpClient.get<Array<Object>>(this.userApi + "enseignant", { params: params });
  }

  getEnseignantsByRegionAndApprentissage(params) {
    return this.httpClient.get<Array<Object>>(this.userApi + "enseignant/region", { params: params });
  }

  getUsersByCriteria(id, name, email, role, nationalities, region, page, pageSize, all?) {
    let param = [];
    let url = this.userApi + "criteria?";
    if (this.trimDefined(id) != undefined)
      param.push({ attribute: "idUniqueCnea", value: this.trimDefined(id) })
    if (this.trimDefined(name) != undefined)
      param.push({ attribute: "userName", value: this.trimDefined(name) })
    if (this.trimDefined(email) != undefined)
      param.push({ attribute: "userEmail", value: encodeURIComponent(this.trimDefined(email)) })
    if (role != undefined)
      param.push({ attribute: "role", value: RoleEnum[role] })
    if (region != undefined)
      param.push({ attribute: "regionId", value: region.id })
    if (nationalities != undefined) {
      let nationalityStr = "";
      console.log("State : " + nationalities);
      for (let i = 0; i < nationalities.length; i++) {
        nationalityStr += nationalities[i]
        if (i != (nationalities.length - 1))
          nationalityStr += ","
      }
      if (nationalityStr != "")
        param.push({ attribute: "status", value: nationalityStr })
    }
    if (!all) {
      param.push({ attribute: "page", value: page })
      param.push({ attribute: "pageSize", value: pageSize })
    }

    for (let i = 0; i < param.length; i++) {
      url += param[i].attribute + "=" + param[i].value;
      if (i != (param.length - 1))
        url += "&"
    }
    return this.httpClient.get<Array<Object>>(url);
  }

  mapEnseignant(userForm, nationality, state) {
    let userDto = this.mapUser(userForm, nationality, state)
    let userData = {
      "apprentissages": this.undefinedIfNull(userForm.value["apprentissages"]),
      "centres": this.undefinedIfNull(userForm.value["centres"]),
      "coursEnseigner": this.undefinedIfNull(userForm.value["coursEnseigner"]),
      "dateFinContrat": this.undefinedIfNull(userForm.value["dateFinContrat"]),
      "dateObtentionGrade": this.undefinedIfNull(userForm.value["dateObtentionGrade"]),
      "datePremierContrat": this.undefinedIfNull(userForm.value["datePremierContrat"]),
      "grade": this.undefinedIfNull(userForm.value["grade"]),
      "idNiveauEducatif": this.undefinedIfNull(userForm.value["idNiveauEducatif"]),
      "identifiantCnea": this.undefinedIfNull(userForm.value["identifiantCnea"]),
      "regimeHeure": this.undefinedIfNull(userForm.value["regimeHeure"]),
      "status": this.undefinedIfNull(userForm.value["status"]),
      "type": this.undefinedIfNull(userForm.value["type"]),
      "typeApprentissages": this.undefinedIfNull(userForm.value["typeApprentissages"]),
      "userDto": userDto
    }
    return userData;
  }

  getRegion(email) {
    return this.httpClient.get(environment.apiServer + "/users/region?email=" + encodeURIComponent(email));
  }

  mapProfile(userForm: FormGroup, nationality) {
    let form = userForm.getRawValue();
    if (nationality.length == 0)
      form["nationaliteIds"] = undefined;
    else
      form["nationaliteIds"] = nationality;
    form["gouvernoratId"] = form["governorate"]
    form["governorate"] = undefined;
    form["delegationId"] = form["delegation"]
    form["delegation"] = undefined;
    form["municipaliteId"] = form["municipality"]
    form["municipality"] = undefined;
    form["imadaId"] = form["imada"]
    form["imada"] = undefined;
    form["codePostal"] = form["postalCode"]
    form["postalCode"] = undefined
    form["civilite"] = form["civility"]
    form["civility"] = undefined
    form["adresse"] = form["address"]
    form["address"] = undefined
    form["rawPhoto"] = undefined
    form["photoProfil"] = form["photo"];
    form["photo"] = undefined;
    for (const [key, value] of Object.entries(form)) {
      if (value == null || value == undefined)
        delete form[key];
    }
    if (!form["photoProfil"])
      form["photoProfil"] = null;
    return form;
  }

  mapUser(userForm: FormGroup, nationality, state) {
    let control = userForm.controls;
    if (nationality.length == 0)
      nationality = undefined;
    let direction = undefined;
    let func = undefined;
    let region = undefined;
    if (control["role"] != undefined) {
      if (control["role"].value == "2" || control["role"].value == "3")
        func = this.trimIfDefined(control['function'])
      else if (control["role"].value == "4")
        direction = control['direction'].value
      else if (control["role"].value == "5")
        region = control['region'].value
    }
    let photo = undefined;
    if ((control["photo"].value != undefined) && (control["photo"].value != null))
      photo = control["photo"].value;
    if (control["role"].value != undefined)
      control["role"].setValue(parseInt(control["role"].value));
    console.log("State : " + state);
    let mappedUser = {
      "imadaId": this.undefinedIfNull(control['imada'].value),
      "firstName": control['firstName'].value.trim(),
      "lastName": control['lastName'].value.trim(),
      "phone": this.trimIfDefined(control['phone']),
      "email": control['email'].value.trim(),
      "civilite": control['civility'].value.trim(),
      "cin": ("" + control['cin'].value).trim(),
      "nationaliteIds": nationality,
      "roleId": this.undefinedIfNull(control['role'].value),
      "gouvernoratId": this.undefinedIfNull(control['governorate'].value),
      "delegationId": this.undefinedIfNull(control['delegation'].value),

      "municipaliteId": this.undefinedIfNull(control['municipality'].value),
      "adresse": this.trimIfDefined(control['address']),
      "codePostal": this.trimIfDefined(control['postalCode']),
      "status": state,
      "directionId": this.undefinedIfNull(direction),
      "fonction": func,
      "regionId": this.undefinedIfNull(region),
      "photoProfil": photo
    }

    return mappedUser;
  }

  initialisationPassword(password, key) {
    let formData = new FormData()
    formData.append("newPassword", password);
    formData.append("activationKey", key);
    return this.httpClient.post(this.userApi + "initPassword", formData)
  }

  undefinedIfNull(element) {
    if (element == null)
      return undefined;
    else
      return element;
  }

  trimIfDefined(element) {
    if ((element != undefined) && (element.value != undefined))
      return ("" + element.value).trim();
    else return undefined
  }

  trimDefined(element) {
    if ((element != undefined) && (element.trim() != ""))
      return element.trim();
    else
      return undefined;
  }

  getEnseignantByRegion(regionId) {
    return this.httpClient.get<Array<Object>>(environment.apiServer + "/users/enseignant/byRegion?regionId=" + regionId);
  }

  getActiveEnseignantsByRegion(idRegion) {
    return this.httpClient.get<Array<Object>>(environment.apiServer + "/users/enseignant/byRegion?regionId=" + idRegion + "&statut=ACTIF");
  }

  getEnseignantByConnectedUser() {
    return this.httpClient.get(environment.apiServer + '/users/enseignant/byUserConnected');
  }

  disableUser(userKey) {
    return this.httpClient.post(environment.apiServer + "/users/desactivate/" + userKey, null);
  }

  reactiveUser(userKey) {
    return this.httpClient.post(environment.apiServer + "/users/activate/" + userKey, null);
  }
}
